// extracted by mini-css-extract-plugin
export var csatScore = "_ls-5";
export var header = "_ls-1";
export var panelWrapper = "_ls-2";
export var postPreview = "_ls-3";
export var rightContent = "_ls-0";
export var wrappingText = "_ls-4";